<template>
	<div class="login">
		<h4>Восстановление пароля</h4>

		<form class="form" @submit.prevent="sendReg">
			<p class="form__field">
				<input class="uk-input" name="email" type="email" placeholder="Введите email" v-model="email">
			</p>

			<div class="form__buttons">
				<button class="uk-button uk-button-primary" type="submit" :disabled="!$root.confid">Восстановить пароль</button>
			</div>
		</form>
	</div>
</template>

<script>
  import Http from "./classes/http";
  export default {
    name: "account-restore",
    data() {
      return {
        http: new Http(this),
        email: ''
      }
    },
    methods: {
      sendReg() {
        this.http.post('RestorePassword::onAjax', { email: this.email })
          .then(res => {
            if (res.data.status) {
              swal('Успешно!', res.data.message, 'success')
            } else {
              swal('Ой!', res.data.message, 'warning')
            }
          })
          .catch(e => swal('Что-то пошло не так', '' + e, 'error'))
      }
    }
  }
</script>